import React from 'react';
import Body from './partials/Body.partial';
import Header from './partials/Header.partial';
import DataFilter from './partials/DataFilter/DataFilter.component';
import ReactPaginate from 'react-paginate';
import './DataTable.style.scss';
import { FaCircleNotch } from 'react-icons/fa';
import HeaderShorting from './partials/HeaderShorting.partial';

class DataTable extends React.Component {
    
    state = {
        filters: null,
        pagination: {
            current: 1,
            limit: 10
        }
    }

    handleFilter = (values) => {
        const self = this;
        const { pagination } = self.state;
        self.setState({
            pagination: {
                ...pagination,
                current: 1
            },
            filters: values
        }, () => this.combineFilter())
    }

    handlePagination = ({ selected }) => {
        const self = this;
        const { pagination } = self.state;
        self.setState({
            pagination: {
                ...pagination,
                current: selected + 1
            }
        }, () => this.combineFilter());
    }

    combineFilter = () => {
        const self = this;
        const { onFilter } = self.props;
        const { filters, pagination } = self.state;

        if (typeof onFilter === 'function') onFilter({
            ...filters,
            pagination
        });
    }

    handleShortClick = (value) => {

        localStorage.setItem("params", value.id);

        this.props.params.updates(value)
    }

    render() {
        const {
            columns,
            rows,
            page,
            className,
            visible = true,
            loading = false,
            classique = false,
            columnsShort = false
        } = this.props;

        const {
            pagination
        } = this.state;

        return (
            <div className={`datatable ${visible ? 'visible' : 'hidden'}`}>
                <div className="datatable-responsive">
                    { classique === false ? (
                        <div className="filters">
                            <DataFilter
                                columns={columns}
                                onFilter={this.handleFilter}/>
                        </div>            
                    ) : null }
                    
                    <table className={`${className} table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer`}>
                        

                        { columnsShort ? (

                            <HeaderShorting
                            onShortColumn={this.handleShortClick}
                            columns={columns}/>

                        ) : <Header
                            columns={columns}/> }
                    


                        { loading === true ? (      
                            <tbody>
                                <tr>
                                    <td colSpan={columns.length + 1} align="center" style={{backgroundColor: '#f7f7f7'}}>
                                        Chargement en cours <FaCircleNotch className="spin-quickly" />
                                    </td>
                                </tr>
                            </tbody>) 
                        : null }
    
                        {/* Handle rows display */}
                        { loading === false && (!rows || rows.length === 0) ? (      
                            <tbody>
                                <tr>
                                    <td colSpan={columns.length + 1} align="center" style={{backgroundColor: '#f7f7f7'}}>
                                        Aucune donnée n'est disponible.
                                    </td>
                                </tr>
                            </tbody>
                            ) 
                        : <Body
                            columns={columns}
                            rows={rows}/> }
                    </table>
                </div>
                
                { classique === false && page && page.hasOwnProperty('number') ? (
                    <div className="table-footer">
                        <div className="pagination-display">Affichage de { pagination.current } sur { page.number } sur un total de : { page.total }</div>
                        <div className="pagination-links">
                            <ReactPaginate
                                breakLabel="..."
                                nextLabel="next >"
                                onPageChange={this.handlePagination}
                                pageRangeDisplayed={3}
                                pageCount={page.number}
                                previousLabel="< previous"
                                renderOnZeroPageCount={null}
                            />
                        </div>7
                    </div>
                ) : null }
            </div>
        )
    }
    
}

export default DataTable;
